var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablerBuildingEstate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 18.2995H17.5M15.8333 18.2995V14.9661M15.8333 14.9661C16.2754 14.9661 16.6993 14.7906 17.0118 14.478C17.3244 14.1654 17.5 13.7415 17.5 13.2995V11.6328C17.5 11.1908 17.3244 10.7669 17.0118 10.4543C16.6993 10.1417 16.2754 9.96615 15.8333 9.96615C15.3913 9.96615 14.9674 10.1417 14.6548 10.4543C14.3423 10.7669 14.1667 11.1908 14.1667 11.6328V13.2995C14.1667 13.7415 14.3423 14.1654 14.6548 14.478C14.9674 14.7906 15.3913 14.9661 15.8333 14.9661ZM11.6667 18.2995V6.63281C11.6667 5.96977 11.4033 5.33389 10.9344 4.86505C10.4656 4.3962 9.82971 4.13281 9.16667 4.13281H5.83333C5.17029 4.13281 4.53441 4.3962 4.06557 4.86505C3.59673 5.33389 3.33333 5.96977 3.33333 6.63281V18.2995M7.5 14.9661V18.2995M6.66667 11.6328H8.33333M6.66667 8.29948H8.33333",
    stroke: "#323232",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerBuildingEstate);
export default __webpack_public_path__ + "static/media/tabler_building_estate.a4571c0a6a21a60551d5dbfd4592dd39.svg";
export { ForwardRef as ReactComponent };